import { useCallback, useEffect, useState } from 'react';
import { getLearnerMilestoneResults, getLearnerMilestoneStatus } from '../../../../../util/APIUtils';
import { PDQ_STATUSES, SUCCESS } from '../../../../services/constants';

export const useMilestoneMapperHook = props => {

  const [status,setStatus] = useState(false);
  const [pdqScores,setPdqScores] = useState({});
  const { user } = props;

  const getMilestoneResults = useCallback(async() => {
    try {
      if (!user?.userId) return;
      const results = await getLearnerMilestoneResults(user.userId);
      if(results && results.status === SUCCESS) {
        setPdqScores(results.payload);
      }
    } catch (error) {
      console.error(error);
    }
  }, [user?.userId]);

  const getMilestoneStatus = useCallback(async() => {
    try {
      if(user && user.userId) {
        const response = await getLearnerMilestoneStatus(user.userId);
        if(response && response.status === SUCCESS) {
          const { assessmentStatus } = response.payload;
          setStatus(assessmentStatus);
          if(assessmentStatus === PDQ_STATUSES.COMPLETED) {
            getMilestoneResults();
          }
        }  
      }
    } catch (error) {
      console.error(error);
    }
  }, [user, getMilestoneResults]);

  useEffect(() => {
    getMilestoneStatus();
  }, [getMilestoneStatus]);

  return { status, pdqScores };
};
